export default "__VITE_ASSET__BXutmX_2__"